/**
 * Getters for the Smart Classifier module.
 * Provides computed access to intent data.
 */
const getters = {
  /**
   * Returns the complete array of configured intents.
   *
   * @param {Object} state - Module state
   * @returns {Array} Array of intent objects
   */
  SMART_CLASSIFIER_INTENTS: (state) => {
    return state.intents;
  },
};

export default getters;
